// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 1rem;
  color: #333;
}

#container {
  max-width: 500px;
}

form {
  margin-bottom: 1rem;
}

label {
  font-size: 0.8rem;
  text-transform: uppercase;
  color: #999;
}

input {
  margin-right: 1rem;
  appearance: none;
  border: 1px solid #ccc;
  padding: 5px 10px;
  border-radius: 5px;
  height: 30px;
}

button {
  appearance: none;
  height: 30px;
  border-radius: 5px;
  border: none;
  padding: 5px 10px;
  background-color: steelblue;
  color: #eee;
  font-weight: 600;
  cursor: pointer;
}

img {
  height: 75px;
  margin-bottom: 1rem;
}

p {
  margin-bottom: 1rem;
}

.condition {
  margin-bottom: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  align-items: center;
}

.condition-label {
  font-size: 0.8rem;
  text-transform: uppercase;
  color: #999;
  justify-self: end;
  text-align: right;
}

.condition-value {
  font-weight: 600;
  justify-self: start;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mJAAmJ;EACnJ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1rem;\n  color: #333;\n}\n\n#container {\n  max-width: 500px;\n}\n\nform {\n  margin-bottom: 1rem;\n}\n\nlabel {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  color: #999;\n}\n\ninput {\n  margin-right: 1rem;\n  appearance: none;\n  border: 1px solid #ccc;\n  padding: 5px 10px;\n  border-radius: 5px;\n  height: 30px;\n}\n\nbutton {\n  appearance: none;\n  height: 30px;\n  border-radius: 5px;\n  border: none;\n  padding: 5px 10px;\n  background-color: steelblue;\n  color: #eee;\n  font-weight: 600;\n  cursor: pointer;\n}\n\nimg {\n  height: 75px;\n  margin-bottom: 1rem;\n}\n\np {\n  margin-bottom: 1rem;\n}\n\n.condition {\n  margin-bottom: 0;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  align-items: center;\n}\n\n.condition-label {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  color: #999;\n  justify-self: end;\n  text-align: right;\n}\n\n.condition-value {\n  font-weight: 600;\n  justify-self: start;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
